import { MUSIC24_TRIAL_DAYS } from 'fym-common/src/license/music24Plans';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * The whole days of trial that are left: each started day of the rest counts as one, so the last
 * hours of the trial read "1 day left". An end time less than one day past the trial length reads
 * as the trial length: on the day of the signup the trial shows `MUSIC24_TRIAL_DAYS` (7), also when
 * the server clock that wrote the end time runs a little ahead of the device (QA finding F08:
 * "8 days left" on a 7-day trial). A trial that support extended (`extendsTrial`) is really longer
 * and shows its real count ("14 days left"). 0 when the trial ended.
 *
 * This is the one rule for every place that shows the days left (`LicenseInfo.trialDaysRemaining`).
 */
export function trialDaysLeft(endsAt: Date, now: Date = new Date()): number {
  const ms = endsAt.getTime() - now.getTime();
  if (ms <= 0) {
    return 0;
  }
  const trialMs = MUSIC24_TRIAL_DAYS * DAY_MS;
  if (ms > trialMs && ms < trialMs + DAY_MS) {
    return MUSIC24_TRIAL_DAYS;
  }
  return Math.ceil(ms / DAY_MS);
}
